import React from 'react'
import {Link} from 'react-router-dom'

import MODES from 'constants/MODES'

const tmpCount = 4242

const CategoryItem = ({category, to}) => (
  <Link to={to} className='searchMainCategories'>
    <span className='searchMainCategories-text'>
      {category.name}
    </span> <span className='searchMainCategories-number'>
      {tmpCount.toLocaleString('en-GB').replace(',', ' ')}
    </span>
  </Link>
)

const Categories = ({t, categories, mode, searchValue}) => (
  <div className='productsList-categories'>
    {mode === MODES.fullSearchResults ? (
      <h4>{t('Show results in these')} <b>{t('categories')}</b></h4>
    ) : mode === MODES.autocomplete ? (
      <h4>{t('Search in these')} <b>{t('categories')}</b></h4>
    ) : mode === MODES.categoryItems ? (
      <h4>{t('Suggested')} <b>{t('sub-categories')}</b> {t('for you')}</h4>
    ) : ''}

    <div>
      <div>
        {categories?.map(e => (
          <CategoryItem
            key={e.categoryUuid}
            to={`/category/${e.alias}/${searchValue}`}
            category={e}
          />
        ))}
      </div>
    </div>
  </div>
)

export default Categories
